// Hook
import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import { DEBOUNCE_TIME_DELAY } from 'utils/commonConstants';

function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  function handleResize() {
    // Set window width/height to state
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }
  // sends updated height only when, Resize is finished(i.e, Difference b/w events is greater than Delay provided)
  const debouncedHandleResize = useCallback(
    _.debounce(handleResize, DEBOUNCE_TIME_DELAY),
    [],
  );
  useEffect(() => {
    // Handler to call on window resize
    // Add event listener
    window.addEventListener('resize', debouncedHandleResize);
    // Call handler right away so state gets updated with initial window size
    debouncedHandleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

export default useWindowSize;
